"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { ApiNotificationCause } from "@/generated/models/ApiNotificationCause";
import { usePrefetchNotifications } from "@/hooks/useNotificationsQuery";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
export interface NotificationFilter {
  cause: ApiNotificationCause[];
  title: string;
}
const NotificationFilters: NotificationFilter[] = [{
  cause: [],
  title: "All"
}, {
  cause: [ApiNotificationCause.IdentityMentioned, ApiNotificationCause.DropQuoted],
  title: "Mentions"
}, {
  cause: [ApiNotificationCause.DropReplied],
  title: "Replies"
}, {
  cause: [ApiNotificationCause.IdentitySubscribed, ApiNotificationCause.IdentityRep, ApiNotificationCause.IdentityNic],
  title: "Identity"
}, {
  cause: [ApiNotificationCause.DropVoted, ApiNotificationCause.DropReacted, ApiNotificationCause.DropBoosted],
  title: "Reactions"
}, {
  cause: [ApiNotificationCause.WaveCreated],
  title: "Invites"
}];
export default function NotificationsCauseFilter(t0) {
  const $ = _c(38);
  const {
    activeFilter,
    setActiveFilter
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const buttonRefs = useRef(t1);
  const highlightRef = useRef(null);
  const activeIndexRef = useRef(0);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const {
    connectedProfile
  } = useContext(AuthContext);
  const prefetchNotifications = usePrefetchNotifications();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = container;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const checkScroll = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const container_0 = containerRef.current;
      if (!container_0) {
        return;
      }
      checkScroll();
      container_0.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      let resizeObserver = null;
      if (typeof ResizeObserver !== "undefined") {
        resizeObserver = new ResizeObserver(() => {
          checkScroll();
        });
        resizeObserver.observe(container_0);
      }
      return () => {
        container_0.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
        resizeObserver?.disconnect();
      };
    };
    t4 = [checkScroll];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const container_1 = containerRef.current;
      if (!container_1) {
        return;
      }
      container_1.scrollBy({
        left: -150,
        behavior: "smooth"
      });
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const scrollLeft_0 = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const container_2 = containerRef.current;
      if (!container_2) {
        return;
      }
      container_2.scrollBy({
        left: 150,
        behavior: "smooth"
      });
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const scrollRight = t6;
  let t7;
  if ($[6] !== connectedProfile || $[7] !== prefetchNotifications) {
    t7 = filter => {
      if (!connectedProfile) {
        return;
      }
      prefetchNotifications({
        identity: connectedProfile.handle,
        cause: filter.cause.length > 0 ? filter.cause : null,
        pages: 1
      });
    };
    $[6] = connectedProfile;
    $[7] = prefetchNotifications;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleHover = t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = filterIndex => {
      const button = buttonRefs.current[filterIndex];
      const highlight = highlightRef.current;
      if (button && highlight) {
        let l = button.offsetLeft;
        let w = button.offsetWidth;
        if (filterIndex === 0) {
          l = l + 2;
          w = w - 2;
        }
        if (filterIndex === NotificationFilters.length - 1) {
          w = w - 2;
        }
        highlight.style.left = `${l}px`;
        highlight.style.width = `${w}px`;
      }
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const updateHighlightPosition = t8;
  let t10;
  let t9;
  if ($[10] !== activeFilter) {
    t9 = () => {
      const idx = activeFilter == null ? 0 : Math.max(0, NotificationFilters.findIndex(f => f.title === activeFilter.title));
      activeIndexRef.current = idx;
      updateHighlightPosition(idx);
      const container_3 = containerRef.current;
      if (!container_3) {
        return;
      }
      const ro = new ResizeObserver(() => updateHighlightPosition(activeIndexRef.current));
      ro.observe(container_3);
      return () => ro.disconnect();
    };
    t10 = [activeFilter];
    $[10] = activeFilter;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  useLayoutEffect(t9, t10);
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  if ($[13] !== activeFilter || $[14] !== handleHover || $[15] !== setActiveFilter) {
    const handleChange = (filter_0, filterIndex_0) => {
      setActiveFilter(filter_0);
      activeIndexRef.current = filterIndex_0;
      updateHighlightPosition(filterIndex_0);
      const button_0 = buttonRefs.current[filterIndex_0];
      const container_4 = containerRef.current;
      if (button_0 && container_4) {
        const containerWidth = container_4.clientWidth;
        const scrollWidth_0 = container_4.scrollWidth;
        const buttonLeft = button_0.offsetLeft;
        const buttonWidth = button_0.offsetWidth;
        let scrollLeft_1 = buttonLeft - containerWidth / 2 + buttonWidth / 2;
        if (scrollLeft_1 < 0) {
          scrollLeft_1 = 0;
        }
        if (scrollLeft_1 > scrollWidth_0 - containerWidth) {
          scrollLeft_1 = scrollWidth_0 - containerWidth;
        }
        container_4.scrollTo({
          left: scrollLeft_1,
          behavior: "smooth"
        });
      }
    };
    let t16;
    if ($[21] !== activeFilter) {
      t16 = filter_1 => activeFilter === filter_1;
      $[21] = activeFilter;
      $[22] = t16;
    } else {
      t16 = $[22];
    }
    const isActive = t16;
    t15 = "tw-relative tw-w-full tw-pb-2 tw-pt-2 lg:tw-pt-4";
    t11 = containerRef;
    t12 = "tw-nowrap tw-relative tw-flex tw-h-10 tw-items-center tw-gap-1 tw-overflow-x-auto tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:tw-hidden";
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div ref={highlightRef} className="tw-absolute tw-h-8 tw-rounded-lg tw-bg-iron-800 tw-transition-all tw-duration-300 tw-ease-in-out" />;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    t14 = NotificationFilters.map((filter_2, index) => <NotificationCauseFilterButton key={`notification-cause-filter-${filter_2.title}`} title={filter_2.title} isActive={isActive(filter_2)} onClick={() => handleChange(filter_2, index)} onMouseEnter={() => handleHover(filter_2)} buttonRef={el => buttonRefs.current[index] = el} />);
    $[13] = activeFilter;
    $[14] = handleHover;
    $[15] = setActiveFilter;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
  } else {
    t11 = $[16];
    t12 = $[17];
    t13 = $[18];
    t14 = $[19];
    t15 = $[20];
  }
  let t16;
  if ($[24] !== t11 || $[25] !== t12 || $[26] !== t13 || $[27] !== t14) {
    t16 = <div ref={t11} className={t12}>{t13}{t14}</div>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== canScrollLeft) {
    t17 = canScrollLeft && <><div className="tw-pointer-events-none tw-absolute tw-bottom-2 tw-left-0 tw-top-2 tw-z-10 tw-w-16 tw-rounded-l-lg tw-bg-gradient-to-r tw-from-iron-950 tw-via-iron-950/40 tw-to-iron-950/0 lg:tw-top-4" /><button type="button" onClick={scrollLeft_0} aria-label="Scroll filters left" className="tw-group tw-absolute tw-left-0 tw-top-1/2 tw-z-20 tw-inline-flex tw-h-10 tw-w-10 tw--translate-y-1/2 tw-items-center tw-justify-start tw-border-none tw-bg-transparent tw-p-0 tw-outline-none"><FontAwesomeIcon icon={faChevronLeft} className="tw-ml-1 tw-h-4 tw-w-4 tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out group-hover:tw-text-iron-300" /></button></>;
    $[29] = canScrollLeft;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== canScrollRight) {
    t18 = canScrollRight && <><div className="tw-pointer-events-none tw-absolute tw-bottom-2 tw-right-0 tw-top-2 tw-z-10 tw-w-16 tw-rounded-r-lg tw-bg-gradient-to-l tw-from-iron-950 tw-via-iron-950/40 tw-to-iron-950/0 lg:tw-top-4" /><button type="button" onClick={scrollRight} aria-label="Scroll filters right" className="tw-group tw-absolute tw-right-0 tw-top-1/2 tw-z-20 tw-inline-flex tw-h-10 tw-w-10 tw--translate-y-1/2 tw-items-center tw-justify-end tw-border-none tw-bg-transparent tw-p-0 tw-outline-none"><FontAwesomeIcon icon={faChevronRight} className="tw-mr-1 tw-h-4 tw-w-4 tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out group-hover:tw-text-iron-300" /></button></>;
    $[31] = canScrollRight;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t15 || $[34] !== t16 || $[35] !== t17 || $[36] !== t18) {
    t19 = <div className={t15}>{t16}{t17}{t18}</div>;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
}
function NotificationCauseFilterButton(t0) {
  const $ = _c(10);
  const {
    title,
    isActive,
    onClick,
    onMouseEnter,
    buttonRef
  } = t0;
  let t1;
  if ($[0] !== isActive) {
    t1 = () => `tw-border-none tw-bg-transparent tw-no-underline tw-flex tw-justify-center tw-items-center
     tw-px-3 tw-py-2 tw-gap-2 tw-flex-1 tw-h-8 tw-rounded-lg tw-transition-colors tw-duration-300
     tw-ease-in-out tw-relative z-10 ${isActive ? "tw-text-iron-300" : "tw-text-iron-400 desktop-hover:hover:tw-text-iron-300"}`;
    $[0] = isActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getLinkClasses = t1;
  const t2 = getLinkClasses();
  let t3;
  if ($[2] !== title) {
    t3 = <span className="tw-text-sm tw-font-semibold">{title}</span>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== buttonRef || $[5] !== onClick || $[6] !== onMouseEnter || $[7] !== t2 || $[8] !== t3) {
    t4 = <button className={t2} onClick={onClick} onMouseEnter={onMouseEnter} ref={buttonRef}>{t3}</button>;
    $[4] = buttonRef;
    $[5] = onClick;
    $[6] = onMouseEnter;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}